<template>
  <div class="fixed-image-container" :style="containerStyle">
    <img
      :src="src"
      :alt="alt"
      class="fixed-image" 
      :style="imageStyle"
      :loading="eager ? 'eager' : 'lazy'"
    />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FixedImage',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    height: {
      type: [String, Number],
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    aspectRatio: {
      type: [String, Number],
      default: null
    },
    cover: {
      type: Boolean,
      default: false
    },
    eager: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerStyle() {
      const style = {};
      
      if (this.height) {
        style.height = isNaN(this.height) ? this.height : `${this.height}px`;
      }
      
      if (this.width) {
        style.width = isNaN(this.width) ? this.width : `${this.width}px`;
      }
      
      if (this.aspectRatio && !this.height) {
        const ratio = parseFloat(this.aspectRatio);
        style.paddingBottom = `${(1 / ratio) * 100}%`;
        style.height = 0;
      }
      
      return style;
    },
    imageStyle() {
      const style = {};
      
      if (this.cover) {
        style.objectFit = 'cover';
      }
      
      return style;
    }
  }
}
</script>

<style scoped>
.fixed-image-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.fixed-image {
  display: block !important;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  visibility: visible !important;
  opacity: 1 !important;
  z-index: 1;
}

/* Quand un aspect ratio est défini, l'image remplit le conteneur */
.fixed-image-container:not([style*="height"]) .fixed-image {
  position: absolute;
  top: 0;
  left: 0;
}
</style>